export enum ReservationTypeOfStay {
  CORPORATES = 'CORPORATES',
  TRAVEL_MANAGEMENT_COMPANY = 'TRAVEL_MANAGEMENT_COMPANY',
  GROUPS = 'GROUPS',
  FREQUENT_INTERNATIONAL_TRAVELER = 'FREQUENT_INTERNATIONAL_TRAVELER',
  BROKER = 'BROKER',
  INDIVIDUAL = 'INDIVIDUAL'
}
